import React, { FC, forwardRef } from "react";

interface InputProps {
  type?: "text" | "number" | "email" | "password" | "date" | "time" | string;
  id?: string;
  name?: string;
  placeholder?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
  min?: string;
  max?: string;
  step?: string | number;
  disabled?: boolean;
  success?: boolean;
  error?: boolean | string;
  hint?: string; // Optional hint text
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  testId?: string; // Добавляем поддержку testId
  inputRef?: React.RefObject<HTMLInputElement>;
}

const Input: FC<InputProps> = ({
  type = "text",
  id,
  name,
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  className = "",
  min,
  max,
  step,
  disabled = false,
  success = false,
  error = false,
  hint,
  testId,
  inputRef,
}) => {
  // Determine input styles based on state (disabled, success, error)
  let inputClasses = `h-11 w-full rounded-lg border appearance-none px-4 py-2.5 text-sm shadow-theme-xs placeholder:text-text-muted focus:outline-none focus:ring bg-bg-input text-text-primary focus:border-brand-300 ${className}`;

  // Add styles for the different states
  if (disabled) {
    inputClasses += ` text-text-muted border-border-input cursor-not-allowed bg-bg-tertiary`;
  } else if (error) {
    inputClasses += ` text-error-800 border-error-500 focus:ring focus:ring-error-500/10`;
  } else if (success) {
    inputClasses += ` text-success-500 border-success-400 focus:ring-success-500/10 focus:border-success-300`;
  } else {
    inputClasses += ` bg-transparent border-border-input focus:border-brand-300 focus:ring focus:ring-brand-500/10`;
  }

  return (
    <div className="relative">
      <input
        ref={inputRef}
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        className={inputClasses}
        data-testid={testId}
      />

      {/* Error or Hint Text */}
      {(error || hint) && (
        <p
          className={`mt-1.5 text-xs ${
            error
              ? "text-error-500"
              : success
              ? "text-success-500"
              : "text-gray-500"
          }`}
        >
          {typeof error === 'string' ? error : hint}
        </p>
      )}
    </div>
  );
};

export default Input;
